import classNames from "classnames";

import { Icon } from "@zapier/zinnia-icons";
import { useTranslations } from "next-intl";

import styles from "./CanvasEmbed.module.css";
import { Link } from "@zapier/design-system";
import { isProduction } from "src/utils/environment";

type CanvasEmbedProps = {
  className?: string;
  url: string;
  showOpenInCanvasButton?: boolean;
};

export function CanvasEmbed({
  url,
  className,
  showOpenInCanvasButton = true,
}: CanvasEmbedProps) {
  const t = useTranslations("TemplateDetail");
  return (
    <div className={classNames(styles.root, className)}>
      {showOpenInCanvasButton && (
        <div className={styles.controls}>
          <Link
            variant="tertiary"
            href={url}
            target="_blank"
            rel="noopener"
            iconPosition="start"
          >
            <Icon name="arrowOffsite" />
            {t("openInCanvas")}
          </Link>
        </div>
      )}
      <iframe
        aria-label={t("canvasIframeTitle")}
        title={t("canvasIframeTitle")}
        // Make URL relative for dev so we can see the Canvas preview before prod
        src={isProduction ? url : url.replace(/^https?:\/\/[^/]+/, "")}
        className={styles.frame}
      />
    </div>
  );
}
